import { BASE_URL } from '../variables';

const getGenericAttachmentUrl = (filename) => {
  return BASE_URL + 'api/attachments/images/download/' + filename;
};

export default getGenericAttachmentUrl;



// WEBPACK FOOTER //
// ./src/helpers/unileverSales/getGenericAttachmentUrl.js